import { rest } from 'msw'

import { getResponseObject } from '@webapp/tests'
import { type DetailedCardApiModel } from '../api-models/DetailedCardApiModel'

export const mockGetDetailedCardSuccess = (data: DetailedCardApiModel) => {
  return rest.get(`/api/v3/pay/cards/${data.external_id}/`, (req, res, ctx) => {
    return res.once(ctx.status(200), ctx.json(getResponseObject(data)))
  })
}

export const mockGetDetailedCardError = (externalId: string) => {
  return rest.get(`/api/v3/pay/cards/${externalId}/`, (req, res, ctx) => {
    return res.once(ctx.status(400))
  })
}
